export default __webpack_public_path__ + "static/media/saas.9d6da21d.png";